if (!customElements.get('monolith-product-recommendations')) {
  customElements.define(
    'monolith-product-recommendations',
    class MonolithProductRecommendations extends HTMLElement {
      async connectedCallback() {
        if (this.dataset.loading === 'true' || this.dataset.loaded === 'true') {
          return;
        }

        const url = this.dataset.url;
        if (!url) return;

        this.dataset.loading = 'true';

        try {
          const load = async (requestUrl) => {
            const response = await fetch(requestUrl);
            if (!response.ok) throw new Error('Empfehlungen konnten nicht geladen werden.');
            const html = document.createElement('div');
            html.innerHTML = await response.text();
            return html.querySelector('monolith-product-recommendations');
          };

          let recommendations = await load(url);
          let usedFallback = false;
          if (!recommendations?.innerHTML.trim() && this.dataset.fallbackUrl && url !== this.dataset.fallbackUrl) {
            recommendations = await load(this.dataset.fallbackUrl);
            usedFallback = true;
          }

          if (recommendations?.innerHTML.trim()) {
            this.innerHTML = recommendations.innerHTML;
            if (usedFallback) {
              const heading = this.querySelector('.monolith-fbt__heading');
              if (heading) heading.textContent = this.dataset.fallbackHeading || heading.textContent;
            }
          }

          this.dataset.loaded = 'true';
        } catch (error) {
          console.error(error);
        } finally {
          delete this.dataset.loading;
        }
      }
    }
  );
}
if (!customElements.get('monolith-frequently-bought')) {
  customElements.define(
    'monolith-frequently-bought',
    class MonolithFrequentlyBought extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.items = Array.from(this.querySelectorAll('[data-fbt-item]'));
        this.button = this.querySelector('[data-fbt-add]');
        this.total = this.querySelector('[data-fbt-total]');
        this.message = this.querySelector('[data-fbt-message]');

        this.button?.addEventListener('click', () => this.addSelected());

        this.items.forEach((item) => {
          item
            .querySelector('[data-fbt-check]')
            ?.addEventListener('change', () => this.update());

          item
            .querySelector('[data-fbt-variant]')
            ?.addEventListener('change', (event) => {
              const option = event.target.selectedOptions[0];

              item.dataset.variantId = event.target.value;
              item.dataset.price = option.dataset.price;

              const price = item.querySelector('[data-fbt-price]');

              if (price) {
                price.textContent = this.formatMoney(
                  Number(option.dataset.price)
                );
              }

              this.update();
            });
        });

        this.update();
      }

      selectedItems() {
        return this.items.filter(
          (item) => item.querySelector('[data-fbt-check]')?.checked
        );
      }

      formatMoney(cents) {
        const currency = this.dataset.currency || 'EUR';
        const locale =
          document.documentElement.lang ||
          window.Shopify?.locale ||
          'de-DE';

        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency
          }).format(cents / 100);
        } catch (error) {
          return `${(cents / 100).toFixed(2)} ${currency}`;
        }
      }

      update() {
        const selected = this.selectedItems();

        const total = selected.reduce(
          (sum, item) => sum + Number(item.dataset.price || 0),
          0
        );

        if (this.total) {
          this.total.textContent = this.formatMoney(total);
        }

        if (this.button) {
          this.button.disabled = selected.length === 0;
        }
        const visuals = Array.from(
  this.querySelectorAll('.monolith-fbt__visual')
);

const plusSigns = Array.from(
  this.querySelectorAll('.monolith-fbt__plus')
);

this.items.forEach((item, index) => {
  const isSelected =
    item.querySelector('[data-fbt-check]')?.checked;

  if (visuals[index]) {
    visuals[index].style.display = isSelected ? 'block' : 'none';
  }
});

plusSigns.forEach((plus) => {
  plus.style.display = 'none';
});

      }

      showMessage(text, isError = false) {
        if (!this.message) return;

        this.message.textContent = text;
        this.message.hidden = !text;
        this.message.classList.toggle('alert--error', isError);
        this.message.classList.toggle('alert--success', !isError);
      }

      async addSelected() {
        const selected = this.selectedItems();

        if (!selected.length || !this.button) return;

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.classList.add('is-loading');
        this.showMessage('');

        try {
          const response = await fetch(
            `${window.Shopify?.routes?.root || '/'}cart/add.js`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: selected.map((item) => ({
                  id: Number(item.dataset.variantId),
                  quantity: 1
                }))
              })
            }
          );

          const result = await response.json();

          if (!response.ok) {
            throw new Error(
              result.description ||
              result.message ||
              this.dataset.errorMessage
            );
          }

          this.showMessage(this.dataset.successMessage);
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          if (typeof window.opusOpen === 'function') {
            window.opusOpen();
          }

          if (typeof window.opusRefreshCart === 'function') {
            window.opusRefreshCart();
          }
        } catch (error) {
          this.showMessage(
            error.message || this.dataset.errorMessage,
            true
          );
        } finally {
          this.button.removeAttribute('aria-busy');
          this.classList.remove('is-loading');
          this.update();
        }
      }
    }
  );
}